import React from "react";
import styles from "./DeliveryInformation.module.css";
import Select from "react-select";

function AdditionalForm(props) {
  return (
    <form className={styles.container}>
      <div className={styles.heading}>
        <h2>Additional Information</h2>
      </div>
      <div className={styles.controls}>
        <label htmlFor="service">Service</label>
        <Select
          options={[
            { value: "ground", label: "Ground" },
            { value: "select", label: "Select" },
            { value: "express", label: "Express" },
          ]}
          onChange={(option) => {
            props.onChange(option.value);
          }}
          required
          placeholder="Service"
          styles={{
            control: (styles) => ({
              ...styles,
              maxWidth: "300px",
            }),
          }}
        />
      </div>
    </form>
  );
}

export default AdditionalForm;
